import * as constant from '../constant.js';

/**
 * 判断是否需要隐藏素材入口和素材弹窗。
 * @param {Object} skuTemplate - 当前 SKU 模板配置。
 * @returns {boolean} 是否需要隐藏素材入口和素材弹窗。
 */
export function shouldHideMaterial(skuTemplate) {
  return (
    !(skuTemplate && skuTemplate.isOutlineLayerSku) && constant.hideMaterial
  );
}
